import axios from "axios";
import { TokenService } from "./storage.service";
import localforage from "localforage";
import memoryDriver from "localforage-memoryStorageDriver";
import { setupCache } from "axios-cache-adapter";
import $ from "jquery";

export const baseAPI_URL = process.env.ROOT_API; // ApiUrl from folder mpob\config\dev.env.js or prod.env.js
const cacheDBName = "AgrinomeDBCache";

localforage.defineDriver(memoryDriver);

// Create `localforage` instance
const forageStore = localforage.createInstance({
    driver: [
        localforage.INDEXEDDB,
        localforage.LOCALSTORAGE,
        memoryDriver._driver
    ],
    name: cacheDBName
});

const cache = setupCache({
    maxAge: 15 * 60 * 1000,
    exclude: {
        query: false
    },
    store: forageStore
});


const ApiConfig = {
    init() {
        axios.defaults.baseURL = baseAPI_URL + "/api/";
    },

    initLongUrl() {
        axios.defaults.baseURL = baseAPI_URL + "/api/services/app/";
    },

    initAxiosCache() {
        axios.defaults.adapter = cache.adapter;
    },

    setHeader() {
        axios.defaults.headers.common["Authorization"] = "Bearer " + TokenService.getToken();
    },

    setTenant() {
        axios.defaults.headers.common["Abp.TenantId"] = process.env.TENANT_ID;
    },

    removeHeader() {
        axios.defaults.headers.common = {};
    },

    removeCacheDB() {
        var indexedDB = window.indexedDB || window.webkitIndexedDB || window.mozIndexedDB || window.moz_indexedDB;
        var request = indexedDB.open(cacheDBName, 2);
        var db;
        request.onsuccess = function(event) {
            db = request.result;
            db
                .transaction("keyvaluepairs", "readwrite")
                .objectStore("keyvaluepairs")
                .clear();
        };
    },

    getHttpOption() {
        return {
            baseUrl: process.env.ROOT_API,
            headers: {
                "Authorization": "Bearer " + TokenService.getToken()
            }
        };
    }
};

ApiConfig.setTenant();
ApiConfig.initLongUrl();
ApiConfig.initAxiosCache();


// BEFORE REQUEST SEND
axios.interceptors.request.use(function (config) {
    setTimeout(function() { $(".spinner-wrapper").show(); }, 100);
    return config;
}, function (error) {
    // IF REQUEST ERROR
    setTimeout(function() { $(".spinner-wrapper").hide(); }, 100);
    return Promise.reject(error);
});


// AFTER GETTING RESPONSE
axios.interceptors.response.use(function (response) {
    setTimeout(function() { $(".spinner-wrapper").hide(); }, 100);
    return response;
}, function (error) {
    // IF RESPONSE ERROR
    setTimeout(function() { $(".spinner-wrapper").hide(); }, 100);

    console.log(error.response);
    if (error.response.data.error) {
        EventBus.$emit("snackBar", {
            text: error.response.status + " - " + error.response.data.error.message,
            snackbarColor: "red lighten-1"
        });
    }
    else if (error.response.statusText) {
        EventBus.$emit("snackBar", {
            text: error.response.status + " - " + error.response.statusText,
            snackbarColor: "red lighten-1"
        });
    }
    else {
        EventBus.$emit("snackBar", {
            text: error.response.status + " - " + error.response.statusText,
            snackbarColor: "red lighten-1"
        });
    }

    return Promise.reject(error);
});


//AJAX CALL
$( document ).ajaxStart(function() {
    $(".spinner-wrapper").show();
});

$( document ).ajaxStop(function() {
    $(".spinner-wrapper").hide();
});

$( document ).ajaxError(function(request, status, error) {
    store.commit("callSnackBar", {
        isSnackbar: true,
        text: status.responseJSON.error.message,
        color: "red lighten-1"
    });
});


export default ApiConfig;



// WEBPACK FOOTER //
// ./src/services/api.service.js